import { MobileRespawnBannerStyled } from "./styled/MobileRespawnBannerStyled";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { BinIcon } from "../../../components/icon/Icon";
import { Button } from "react-bootstrap";
import MobileBonusBanner from "./MobileBonusBanner";
import { useCallback } from "react";
import { openMobileSliderPageAction } from "../../mobileAppActions";
import { MOBILE_SLIDER_PAGES_IDS } from "../MobileSliderPages/mobileSliderPagesConstants";
import { useDispatch } from "react-redux";
import { setNewLifeRespawnBannerOpened } from "../../../modules/Bonus/bonusesActions";

function MobileRespawnBanner(props) {
    const {allowClose} = props;
    const {getLangPath} = useLangContext();

    const dispatch = useDispatch();

    const handleOpenRespawn = useCallback(() => {
        dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.RESPAWN));
    }, [dispatch]);

    const handleClose = useCallback(() => {
        dispatch(setNewLifeRespawnBannerOpened(false))
    }, [dispatch]);

    return <MobileRespawnBannerStyled>
        <MobileBonusBanner
            allowClose={allowClose}
            description={getLangPath('bonus.new_life.your_risk_free_deposit')}
            handleClose={handleClose}
            title={getLangPath('bonus.new_life.respawn_title')}
        >
            <Button
                onClick={handleOpenRespawn}
                size={'lg'}
                variant={'primary'}
            >
                <span className={'me-2'}>{getLangPath('bonus.new_life.see_details')}</span>
                <BinIcon name={'IcForward'}/>
            </Button>
        </MobileBonusBanner>
    </MobileRespawnBannerStyled>
}

export default MobileRespawnBanner;
